export default [{"url":"https://shoper-0.api.invexerp.io","name":"Branch 1","port":"6536","isStore":true,"isHQ":true}]